import { runToast } from "../../../../../_metronic/helpers/utils";
import React from "react";
import { BorderWrapper } from "../index";
import Spinner from "react-bootstrap/Spinner";
import exelImg from "../../../../../_metronic/assets/customIcons/exel.png";

function FileDownloader({ downloadFunc }) {
  //Handlers
  const handleClick = async () => {
    setExcelIsLoading(true);
    try {
      const data = await downloadFunc();
    } catch (e) {
      runToast("اشکال در دانلود", "error", { toastId: 1 });
      console.log(e);
    } finally {
      setExcelIsLoading(false);
    }
  };
  const [excelIsLoading, setExcelIsLoading] = React.useState(false);

  return (
    <BorderWrapper style={{ maxWidth: "fit-content", padding: "5px" }}>
      {excelIsLoading ? (
        <Spinner animation={"grow"} />
      ) : (
        <a className={"cursor-pointer"} onClick={handleClick}>
          <img src={exelImg} />
        </a>
      )}
    </BorderWrapper>
  );
}

export default FileDownloader;
